import React, {useRef} from 'react';
import {useEffect, useState} from 'react'
import {
  SDrawerOrModal, SGeneralForms,
} from 'shj-components'
import {Form, Input, DatePicker, InputNumber} from 'antd';
import dayjs from 'dayjs';

export default function DelayReassignModal({
                                                  editId = '',
                                                  open = false,
                                                  basicInfo = {},
                                                  onClose = () => {
                                                  },
                                                  reload = () => {
                                                  },
                                                }) {
  const formRef = useRef()
  const [loading, setLoading] = useState(false);
  const onFormRef = () => {
    const {onFormRef} = formRef.current || {};
    return onFormRef?.()
  }

  useEffect(() => {
    onFormRef()?.setFieldsValue({
      id: editId,
      handoverDate: (basicInfo as any)?.houseInfo?.handoverDate,
      layout: (basicInfo as any)?.houseInfo?.layout,
      innerArea: (basicInfo as any)?.houseInfo?.innerArea,
      designStyleCode: (basicInfo as any)?.dtlInfo?.designStyleCode,
      budget: (basicInfo as any)?.dtlInfo?.budget,
    })
  }, []);

  const onSubmit = () => {
    onFormRef()?.validateFields().then(async (values: any) => {
      try {
        setLoading(true);
        // const res: any = await confirmArrive({ trackPlanId: editId, buttonKey, ...values })
        setLoading(false);
        // if (res.errorCode === 0 && res.status) {
        //   message.success('确认到店成功');
        //   onClose();
        //   reload();
        // } else {
        //   message.error('确认到店失败');
        // }
      } catch (err) {
        setLoading(false);
        console.log(err)
      }
    })
  }

  return (
      <div>
        <SDrawerOrModal
            mode="modal"
            open={open}
            onCancel={() => onClose()}
            onOk={onSubmit}
            loading={loading}
            title="延期改派"
        >
          <SGeneralForms
              layout={'vertical'}
              ref={formRef}
              isDetail={true}
              configs={[{
                formItem: [
                  {spanCol: 12, label: '销售计划ID', name: 'id'},
                  {spanCol: 12, label: '创建时间', name: 'createTime', itemType: 'dateTime'},
                  {spanCol: 12, label: '客户姓名', name: 'name'},
                  {spanCol: 12, label: '转化天数', name: 'day'},
                  {spanCol: 12, label: '房屋状态', name: 'state'},
                  {spanCol: 12, label: '交房时间', name: 'name', itemType: 'dateTime'},
                  {spanCol: 12, label: '已延期次数', name: 'count'},
                  {
                    spanCol: 12,
                    label: '延期天数',
                    name: 'delay',
                    children: <InputNumber min={1} max={999999999} placeholder={'请输入延期天数'}/>
                  },
                ]
              }]}
          />
        </SDrawerOrModal>
      </div>
  )
}